import {
  actualizarEncuesta,
  crearEncuesta,
  eliminarEncuesta,
  getEncuestaPorId,
  getEncuestas,
} from 'api/encuesta'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import swal from 'sweetalert2'

const key = 'Encuestas'
export function useObtenerEncuesta(buscar) {
  return useQuery(key, () => getEncuestas(buscar))
}

export function useObtenerEncuestaPorId(id) {
  return useQuery('Encuesta', () => getEncuestaPorId(id))
}

export function useCrearEncuesta() {
  const queryClient = useQueryClient()
  return useMutation(crearEncuesta, {
    onSuccess: (response) => {
      const { data } = response
      queryClient.setQueryData(key, (prevState) => {
        const results = [data, ...prevState.results]
        return { ...prevState, results }
      })
    },
  })
}

export function useActualizarEncuesta() {
  const queryClient = useQueryClient()
  return useMutation(actualizarEncuesta, {
    onSuccess: (_, value) => {
      const { id, values: EncuestaActualizada } = value
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.map((Encuesta) => {
          let nuevoEncuesta = Encuesta
          if (id === Encuesta.id) {
            nuevoEncuesta = EncuestaActualizada
          }
          return nuevoEncuesta
        })
        return { ...prevState, results }
      })
    },
  })
}

export function useEliminarEncuesta() {
  const queryClient = useQueryClient()
  return useMutation(eliminarEncuesta, {
    onSuccess: (_, value) => {
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.filter(
          (Encuesta) => Encuesta.id !== value.id,
        )
        return { ...prevState, results }
      })
    },
  })
}

export function useEncuesta(onToggle) {
  const queryClient = useQueryClient()
  const { mutateAsync: eliminarEncuesta } = useEliminarEncuesta()
  const { mutateAsync: actualizarEncuesta } = useActualizarEncuesta()
  const { mutateAsync: crearEncuesta } = useCrearEncuesta()

  const handleCrearEncuesta = async (values, acciones) => {
    try {
      const { data, onSuccessMessage } = await crearEncuesta(values)
      const message = `La Encuesta ${data.nombre} fue creada satisfactoriamente!`
      onSuccessMessage({ text: message })
      acciones.resetForm()
      onToggle()
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleActualizarEncuesta = async ({ id, values, acciones }) => {
    try {
      const { data, onSuccessMessage } = await actualizarEncuesta({
        id,
        values,
      })
      if (data) {
        onSuccessMessage({
          text: 'La Encuesta fue actualizada satisfactoriamente!',
        })
        onToggle()
      }
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleEliminarEncuesta = (encuesta) => {
    swal
      .fire({
        title: 'Estás seguro?',
        text: 'Recuerda que no podrás revertir estos cambios!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminalo!',
      })
      .then(async ({ value }) => {
        if (value) {
          const { data, onSuccessMessage } = await eliminarEncuesta(encuesta)
          const message = `La Encuesta ${data} fue eliminada satisfactoriamente!`
          onSuccessMessage({ text: message })
        }
      })
  }

  const handleBuscarEncuesta = async (value) => {
    queryClient.prefetchQuery(key, () => getEncuestas(value))
  }

  return {
    obtenerEncuestas: useObtenerEncuesta,
    handleEliminarEncuesta,
    handleActualizarEncuesta,
    handleCrearEncuesta,
    handleBuscarEncuesta,
    handleBuscarEncuestaPorId: useObtenerEncuestaPorId,
  }
}
